module.exports = __webpack_public_path__ + "images/031083cf00148091a10098f91e314a9d-saveG.svg";